/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';
import type { CustomRowSelectionChoice } from './CustomRowSelectionChoice';
import {
    CustomRowSelectionChoiceFromJSON,
    CustomRowSelectionChoiceFromJSONTyped,
    CustomRowSelectionChoiceToJSON,
} from './CustomRowSelectionChoice';
import type { RowSelection } from './RowSelection';
import {
    RowSelectionFromJSON,
    RowSelectionFromJSONTyped,
    RowSelectionToJSON,
} from './RowSelection';

/**
 * 
 * @export
 * @interface RowSelectionSettings
 */
export interface RowSelectionSettings {
    /**
     * 
     * @type {RowSelection}
     * @memberof RowSelectionSettings
     */
    activeRowSelection?: RowSelection;
    /**
     * 
     * @type {Array<CustomRowSelectionChoice>}
     * @memberof RowSelectionSettings
     */
    customRowSelectionChoices: Array<CustomRowSelectionChoice>;
    /**
     * 
     * @type {Command}
     * @memberof RowSelectionSettings
     */
    updateRowSelectionCommand: Command;
}

/**
 * Check if a given object implements the RowSelectionSettings interface.
 */
export function instanceOfRowSelectionSettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "customRowSelectionChoices" in value;
    isInstance = isInstance && "updateRowSelectionCommand" in value;

    return isInstance;
}

export function RowSelectionSettingsFromJSON(json: any): RowSelectionSettings {
    return RowSelectionSettingsFromJSONTyped(json, false);
}

export function RowSelectionSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RowSelectionSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activeRowSelection': !exists(json, 'activeRowSelection') ? undefined : RowSelectionFromJSON(json['activeRowSelection']),
        'customRowSelectionChoices': ((json['customRowSelectionChoices'] as Array<any>).map(CustomRowSelectionChoiceFromJSON)),
        'updateRowSelectionCommand': CommandFromJSON(json['updateRowSelectionCommand']),
    };
}

export function RowSelectionSettingsToJSON(value?: RowSelectionSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activeRowSelection': RowSelectionToJSON(value.activeRowSelection),
        'customRowSelectionChoices': ((value.customRowSelectionChoices as Array<any>).map(CustomRowSelectionChoiceToJSON)),
        'updateRowSelectionCommand': CommandToJSON(value.updateRowSelectionCommand),
    };
}

